// extracted by mini-css-extract-plugin
export default {"buttonContainer":"E-W6g","alignToEdge":"JxAGQ","buttonIcon":"oCWhb","buttonCaption":"udIgR","buttonSpacer":"_4ypMp"};